import React from 'react'

export const Facebook = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.4286 0.714355H2.57143C1.88944 0.714355 1.23539 0.985273 0.753154 1.46751C0.270918 1.94975 0 2.6038 0 3.28578L0 22.1429C0 22.8249 0.270918 23.479 0.753154 23.9612C1.23539 24.4434 1.88944 24.7144 2.57143 24.7144H9.92411V16.5549H6.54911V12.7144H9.92411V9.78721C9.92411 6.45775 11.9063 4.61864 14.9421 4.61864C16.3961 4.61864 17.9164 4.87793 17.9164 4.87793V8.14578H16.2413C14.5907 8.14578 14.0759 9.17007 14.0759 10.2206V12.7144H17.7605L17.1713 16.5549H14.0759V24.7144H21.4286C22.1106 24.7144 22.7646 24.4434 23.2468 23.9612C23.7291 23.479 24 22.8249 24 22.1429V3.28578C24 2.6038 23.7291 1.94975 23.2468 1.46751C22.7646 0.985273 22.1106 0.714355 21.4286 0.714355V0.714355Z"
        fill="#111827"
      />
    </svg>
  )
}
